import axios from "axios";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

// Function to create a family member
export const createFamilyMember = async (familyMemberData) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/family-member`, familyMemberData, {
            headers: { "Content-Type": "application/json" },
        });
        return response.data;
    } catch (error) {
        console.error("Error creating family member:", error);
        throw error.response?.data || { message: "Something went wrong" };
    }
};

export const listFamilyMembers = async (userId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/family-members`, {
            params: { user_id: userId },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching family members:", error);
        throw error.response?.data || { message: "Something went wrong" };
    }
};

export const getFamilyMember = async (id, userId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/family-member/${id}`, {
            params: { user_id: userId },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching family member:", error);
        throw error.response?.data || { message: "Something went wrong" };
    }
}

export const updateFamilyMember = async (id, familyMemberData) => {
    try {
        const response = await axios.patch(`${API_BASE_URL}/family-member/${id}`, familyMemberData, {
            headers: { "Content-Type": "application/json" },
        });
        return response.data;
    } catch (error) {
        console.error("Error updating family member:", error);
        throw error.response?.data || { message: "Something went wrong" };
    }
};

export const deleteFamilyMember = async (id, userId) => {
    try {
        const response = await axios.delete(`${API_BASE_URL}/family-member/${id}`, {
            params: { user_id: userId },
        });
        return response.data;
    } catch (error) {
        console.error("Error deleting family member:", error);
        throw error.response?.data || { message: "Something went wrong" };
    }
};
